import { type WalletLedger } from '@capsicum/common';
import { useCallback } from 'react';

import { useNativeCurrenciesQuery } from './../data-access/queries/useNativeCurrenciesQuery';

/**
 *
 * @param networkName
 * @returns ledger - raw data returned from BE
 */
export const useNativeCurrencyNetwork = (networkName?: string) => {
	return useNativeCurrenciesQuery(
		useCallback(
			(data: Array<WalletLedger> | undefined): WalletLedger => {
				const networkData =
					(data?.find(n => n?.currencyNetwork?.network?.type === networkName) as WalletLedger) || {};

				return networkData;
			},
			[networkName]
		)
	);
};
